var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white px-3 index",style:({height:_vm.height})},[_c('img',{staticStyle:{"width":"200px"},attrs:{"src":require("../../../assets/imgs/home/icon.png"),"alt":""}}),_c('img',{staticClass:"welcome",attrs:{"src":require("../../../assets/imgs/home/welcome.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }